import { Plugin } from "@nuxt/types";
import Vue from "vue";

export interface FeedbackToast {
  id: number;
  title: string;
  severity: "success" | "warning" | "error" | "active";
  timeout: number;
}

export interface FeedbackProvider {
  toasts: FeedbackToast[];
  ok(message: string): void;
  warning(message: string): void;
  error(message: string): void;
  active(message: string): void;
  removeToast(id: number): void;
}

declare module "vuex/types/index" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Store<S> {
    $feedback: FeedbackProvider;
  }
}

declare module "vue/types/vue" {
  interface Vue {
    $feedback: FeedbackProvider;
  }
}

const feedbackPlugin: Plugin = (context, inject) => {
  const feedback = Vue.observable({
    toasts: [] as FeedbackToast[],

    ok(message: string) {
      feedback.toasts.push({
        id: Date.now(),
        title: context.app.i18n.t(message) as string,
        severity: "success",
        timeout: 5000,
      });
    },

    warning(message: string) {
      feedback.toasts.push({
        id: Date.now(),
        title: context.app.i18n.t(message) as string,
        severity: "warning",
        timeout: 5000,
      });
    },

    error(message: string) {
      feedback.toasts.push({
        id: Date.now(),
        title: context.app.i18n.t(message) as string,
        severity: "error",
        timeout: 5000,
      });
    },

    active(message: string) {
      feedback.toasts.push({
        id: Date.now(),
        title: context.app.i18n.t(message) as string,
        severity: "active",
        timeout: 5000,
      });
    },

    removeToast(id: number) {
      feedback.toasts = feedback.toasts.filter((toast) => toast.id !== id);
    },
  });

  inject("feedback", feedback);
};

export default feedbackPlugin;
